import Pricing from "@/components/Pricing";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import usePlanInfoStore from "@/store/zustand/planInfoStore";

export default function UpgradeModal() {
  // Access upgrade modal state
  const showUpgradeModal = usePlanInfoStore((state) => state.showUpgradeModal);
  const setShowUpgradeModal = usePlanInfoStore(
    (state) => state.setShowUpgradeModal,
  );

  return (
    <Dialog open={showUpgradeModal} onOpenChange={setShowUpgradeModal}>
      <DialogContent
        className="min-w-full min-h-full max-h-full p-0 bg-[#131519] overflow-y-scroll"
        hideClose={true}
      >
        <Pricing onClose={() => setShowUpgradeModal(false)} />
      </DialogContent>
    </Dialog>
  );
}
